module.exports = "pegasus_template/assets/custom-3-facebook.png";